import { PackageService } from '../../../services/package-service';

import type { FreightBrowserFormState } from '@shipstation/client-common/components/freight-browser';

export type RateBrowserSelectedPackage = {
  packageTypeId: string;
  id: string;
  nameMessageId: string;
  dimensions: { length: number; width: number; height: number; unit: string };
};

export type FreightToRateBrowserDefaults = {
  shipFromId: string;
  shipToCountryCode: string;
  shipToPostalCode: string;
  shipToCityOrSuburb: string;
  isResidential: boolean;
  weight: { weightUnit: string; weight: number };
  dimensions: { length: number; width: number; height: number; unit: string };
  selectedPackage: RateBrowserSelectedPackage;
};

const DEFAULT_WEIGHT_UNIT = 'Ounces';
const DEFAULT_DIMENSION_UNIT = 'Unknown';

const buildAllPackageTypesSelection = (): RateBrowserSelectedPackage => {
  const allPackageTypesId = PackageService.getAllPackageTypesId();
  return {
    packageTypeId: allPackageTypesId,
    id: allPackageTypesId,
    nameMessageId: 'allPackageTypes',
    dimensions: { length: 0, width: 0, height: 0, unit: 'Unknown' },
  };
};

export const mapFreightFormToRateBrowserDefaults = (formState: FreightBrowserFormState): FreightToRateBrowserDefaults => {
  const [handlingUnit] = formState.handlingUnits;
  const [commodity] = handlingUnit?.commodities ?? [];

  return {
    shipFromId: formState.shipFromId ?? '',
    shipToCountryCode: formState.destination.countryCode || 'US',
    shipToPostalCode: formState.destination.postalCode ?? '',
    shipToCityOrSuburb: formState.destination.city ?? '',
    isResidential: formState.additionalServices.isResidentialDelivery ?? false,
    weight: {
      weightUnit: commodity?.weightUnit ?? DEFAULT_WEIGHT_UNIT,
      weight: commodity?.weight ?? 0,
    },
    dimensions: {
      length: handlingUnit?.length ?? 0,
      width: handlingUnit?.width ?? 0,
      height: handlingUnit?.height ?? 0,
      unit: handlingUnit?.dimensionUnit ?? DEFAULT_DIMENSION_UNIT,
    },
    selectedPackage: buildAllPackageTypesSelection(),
  };
};
